import React from 'react';
import enhance from './DiscoverInfluencers.enhancer';
import SwipeableViews from 'react-swipeable-views';
import { virtualize, bindKeyboard } from 'react-swipeable-views-utils';
import InfluencerList from './InfluencerList';
import DealForm from '../../deals/new-deal/DealForm';

const VirtualizeSwipeableViews = bindKeyboard(virtualize(SwipeableViews));

class DiscoverInfluencers extends React.Component {
  constructor() {
    super();

    this.initialState = {
      index: 0,
      campaign: null
    };

    this.state = {
      ...this.initialState
    };
  }

  handleNextClick() {
    const newIndex = this.state.index + 1;
    this.setState({
      index: newIndex
    });
  }

  handleBackClick() {
    const newIndex = this.state.index - 1;
    this.setState({
      index: newIndex
    });
  }

  handleBackToListClick() {
    this.setState({
      index: 0
    });
  }

  proposeDealClick = (influencer, campaign) => {
    this.setState({
      dealRecipient: influencer,
      campaign,
      index: 1
    });
  };

  getStepContent(params) {
    const { key } = params;
    switch (this.state.index) {
      case 0:
        return (
          <InfluencerList
            proposeDealClick={this.proposeDealClick}
            campaign={this.props.campaign}
          />
        );
      case 1:
        return (
          <DealForm
            key={key}
            handleBackClick={this.handleBackClick.bind(this)}
            handleBackToListClick={this.handleBackToListClick.bind(this)}
            currentDeal={this.state.currentDeal}
            user={this.props.auth}
            onProposalComplete={this.handleBackToListClick.bind(this)}
            dealRecipient={this.state.dealRecipient}
            campaign={this.state.campaign}
          />
        );
    }
  }

  render() {
    const { classes, campaign, campaigns } = this.props;
    const {} = this.state;

    return (
      <React.Fragment>
        <VirtualizeSwipeableViews
          style={{ width: '100%' }}
          slideCount={2}
          index={this.state.index}
          slideRenderer={this.getStepContent.bind(this)}
          disabled={true}
        />
      </React.Fragment>
    );
  }
}

export default enhance(DiscoverInfluencers);



// WEBPACK FOOTER //
// ./src/components/company/discover-influencers/DiscoverInfluncers.js